import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import IMDA_SME_Medium from "../../../images/v2/psg/IMDA_SME_Medium.webp";
import { motion } from "framer-motion";

export default function IMDALockup() {
   const useStyles = makeStyles((theme) => ({
      lockupContainer: {
         padding: "0",
         maxWidth: "1200px",
         "@media only screen and (min-width: 1900px)": {
            maxWidth: "1280px",
         },
      },
      SmeStyling: {
         width: "100%",
         margin: "0px auto 0",
         [theme.breakpoints.down("sm")]: {
            width: "100%",
            margin: "0px auto 0",
         },
      },
      smeFooterText: {
         [theme.breakpoints.down("sm")]: {
            fontSize: "14px",
            textAlign: "center",
         },
      },
   }));
   const classes = useStyles();
   return (
      <Container className={classes.lockupContainer} maxWidth={false}>
         <Box textAlign="center">
            <motion.img
               className="smeImg"
               onClick={() =>
                  window.open(
                     "https://smesgodigital.gov.sg/web/go-digital-advisor?utm_source=PA+vendor&utm_medium=vendor+site&utm_campaign=SN222",
                  )
               }
               initial={{ opacity: 0, y: 80 }}
               whileInView={{ opacity: 1, y: 0 }}
               transition={{ duration: 1 }}
               viewport={{ once: true }}
               src={IMDA_SME_Medium}
               style={{ cursor: "pointer" }}
               alt="Pepper Cloud AI WhatsApp CRM + IMDA SME Go Digital + business grant"
            ></motion.img>
            <Box className={classes.SmeStyling}>
               <motion.p
                  className="font-18 font-montserrat-regular"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1 }}
                  viewport={{ once: true }}
                  aria-label="Pepper Cloud Supported by IMDA"
               >
                  SMEs are eligible for up to 50% business grant support for the
                  adoption of Pepper Cloud CRM, a Pre-Approved Solution under
                  the IMDA SMEs Go Digital programme.
               </motion.p>
            </Box>
         </Box>
      </Container>
   );
}
